import { ComponentRef, Directive, Input, OnChanges, OnInit, Type, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import { ClearanceItemImageComponent } from './clearance-item-image.component';
import { ClearanceItemDocumentComponent } from './clearance-item-document.component';
import { AssetConfig } from './asset-config.interface';
import { IAsset } from './asset.interface';

const components: { [type: string]: Type<ClearanceItemAssetBaseComponent> } = {
  image: ClearanceItemImageComponent,
  document: ClearanceItemDocumentComponent
};

@Directive({
  selector: '[dynamicAsset]',
  standalone: false,
})
export class AssetDirective implements OnChanges, OnInit {
  @Input()
  config: AssetConfig;
  @Input()
  assetType: string;
  @Input()
  group: FormGroup;
  @Input()
  hideReportDefaultIcons: boolean;
  @Input()
  preventRemoval: boolean;
  @Input()
  current: number

  @Output() removeAsset = new EventEmitter<number>();
  @Output() enlargeAsset = new EventEmitter<FormGroup>();
  @Output() setDefault = new EventEmitter<FormGroup>();
  @Output() showOnReport = new EventEmitter<FormGroup>();
  @Output() download = new EventEmitter<FormGroup>();

  component: ComponentRef<ClearanceItemAssetBaseComponent>;

  constructor(
    private container: ViewContainerRef
  ) { }

  ngOnChanges() {
    if (this.component) {
      this.setValuesOnProperties();
    }
  }

  ngOnInit() {
    if (!components[this.assetType]) {
      const supportedTypes = Object.keys(components).join(', ');
      throw new Error(
        `Trying to use an unsupported type (${this.assetType}). Supported types: ${supportedTypes}`
      );
    }
    this.component = this.container.createComponent(components[this.assetType]);
    this.setValuesOnProperties();
  }

  setValuesOnProperties() {
    this.component.instance.assetItemForm = this.group;
    this.component.instance.current = this.current;
    this.component.instance.hideReportDefaultIcons = this.hideReportDefaultIcons;
    this.component.instance.preventRemoval = this.preventRemoval;
    this.component.setInput('group', this.group);
    this.component.setInput('current', this.current);
    this.component.setInput('hideReportDefaultIcons', this.hideReportDefaultIcons);
    this.component.setInput('preventRemoval', this.preventRemoval);
    this.component.instance.enlarge = this.enlargeAsset;
    this.component.instance.showOnReport = this.showOnReport;
    this.component.instance.download = this.download;
    this.component.instance.remove = this.removeAsset;
    this.component.instance.setDefault = this.setDefault;
    this.component.changeDetectorRef.detectChanges();
  }
}